import Dialog from '@material-ui/core/Dialog';
import { useState } from 'react';
import { useHistory } from 'react-router';
import AddName from '../../../components/AddSession/AddName.component';
import ImportSession from '../../../components/AddSession/ImportSession.component';
import NewSessionDetails from '../../../components/AddSession/NewSessionDetails.component';
import SelectSession from '../../../components/AddSession/SelectSession.component';
import SelectSystem from '../../../components/AddSession/SelectSystem.component';
import Loader from '../../../components/Loader/Loader.component';
import { Prompt } from '../../../components/Prompt/Prompt.component';
import { ExamSession, ExamSessionDto, Exam, ExamSheetType } from '../../../models/examSessionDto.types';
import {
  saveSessionCreatedManually,
  saveSessionImportedFromExternalSystem,
} from '../../../services/exams/sessions/sessions.service';
import { useStyles } from './SessionCreate.styles';
import { ImportedExamSession } from '../../../models/examSessionDto.types';
import {
  ISavedSessionImportedFromExternalSystem,
  ISavedSessionCreatedManually,
  IExternalSystem,
  ExamSessionSioePkz,
  ExamSheetSieoPkz,
  dtoSioePkz,
} from '../../../models/session.types';
import { AxiosResponse } from 'axios';
import { ButtonOne } from '../../../components/ButtonOne/ButtonOne.component';
import { useTranslation } from 'react-i18next';
import { Paths } from '../../../utils/routerUrls';
import { useLayoutContext } from '../../../Context/Layout.context';

const SessionCreate: React.FC<{
  onCreation: () => void;
}> = (props) => {
  const { t } = useTranslation();
  const { showLoader } = useLayoutContext();
  const [name, setName] = useState<string>('');
  const [system, setSystem] = useState<IExternalSystem | undefined>(undefined);
  const [newExamSheetID, setNewExamSheetID] = useState<string>('');
  const history = useHistory();

  const [open, setOpen] = useState<boolean>(false);
  const [isNewSessionAddedOpen, setIsNewSessionAddedOpen] = useState<boolean>(false);
  const [onNewSessionAdded, setOnNewSessionAdded] = useState<(() => void) | null>(null);

  const [stage1, setStage1] = useState<boolean>(true);
  const [stage2, setStage2] = useState<boolean>(false);
  const [stage3, setStage3] = useState<boolean>(false);
  const [stage4, setStage4] = useState<boolean>(false);
  const [stageSessionDetails, setStageSessionDetails] = useState<boolean>(false);
  const [isImporting, setIsImporting] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);
  const [isImportedSheetsError, setIsImportedSheetsError] = useState<boolean>(false);
  const [existingExamSheetCodes, setExistingExamSheetCodes] = useState<string[]>([]);

  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [isTrainingSession, setIsTrainingSession] = useState<boolean>(false);

  const classes = useStyles();

  const handleClickOpen = () => {
    setStage1(true);
    setStage2(false);
    setStage3(false);
    setStage4(false);
    setIsError(false);
    setIsSuccess(false);
    setStageSessionDetails(false);
    setOpen(true);
  };

  const handleClose = () => {
    setStage1(true);
    setStage2(false);
    setStage3(false);
    setStage4(false);
    setIsError(false);
    setIsSuccess(false);
    setStageSessionDetails(false);
    setIsTrainingSession(false);
    setOpen(false);
  };

  const goToDetails = (newId?: string) => {
    setOpen(false);
    history.push(`${Paths.sessions}/${newId ? newId : newExamSheetID}`);
  };

  const handleAddName = (close: boolean, next: boolean, name: string) => {
    if (close) setOpen(false);
    else {
      if (next) {
        if (isTrainingSession) {
          setStage1(false);
          setStageSessionDetails(true);
        } else {
          setStage1(false);
          setStage2(true);
        }
      }
      if (name != '') setName(name);
    }
  };

  const handleImportSession = (close: boolean, next: boolean, isImport: boolean) => {
    if (close) setOpen(false);
    else {
      if (next) setStage2(false);
      if (isImport) setStage3(true);
      else setStageSessionDetails(true);
    }
  };

  const handleSelectSystem = (close: boolean, next: boolean, system: IExternalSystem | undefined) => {
    if (close) {
      setOpen(false);
    } else {
      if (next) {
        setStage3(false);
      }
      setStage4(true);
      if (system) {
        setSystem(system);
      }
    }
  };

  const handleStageFourAndSave = (
    close: boolean,
    session: ImportedExamSession,
    exams: Exam[],
    sheetTypes: ExamSheetType[],
  ) => {
    if (close) {
      setOpen(false);
    } else {
      setIsImporting(true);
      const examSessionSioePkz: ExamSessionSioePkz = {
        dateBegin: session.dateBegin,
        id: session.id.toString(),
        name: name,
        okeExamResultSubmitDate: null,
      };
      const qualifications = () => {
        return exams.map((item) => {
          return {
            id: item.id.toString(),
            name: item.name,
            description: item.description,
          };
        });
      };
      const examSheetsSioePkz = () => {
        return sheetTypes.map((item) => {
          return {
            id: item.id.toString(),
            customNumber: item.customNumber,
          };
        });
      };
      const examSession: ExamSession = {
        id: session.id,
        number: session.number?.toString(),
        name: session.name,
        userEnteredSessionName: name,
        oneId: '',
      };
      const dto: ExamSessionDto = {
        sourceSystemType: system!.id, //1 = SIOEOE, 2 = SIOEPKZ, 3 = ONE for DEV
        examSession: examSession,
        exams: exams,
        examSheetTypes: sheetTypes,
      };

      const dtoSioePkz: dtoSioePkz = {
        examSession: examSessionSioePkz,
        examSheets: examSheetsSioePkz(),
        qualifications: qualifications(),
      };

      showLoader(true, 'Zapisywanie danych');
      saveSessionImportedFromExternalSystem(system?.id === 2 ? dtoSioePkz : dto, system?.name)
        .then(
          (result: AxiosResponse<ISavedSessionImportedFromExternalSystem>) => {
            if (result.status === 201) {
              if (result.data.existingExamSheetCodes !== null) {
                setIsImportedSheetsError(true);
                setExistingExamSheetCodes(result.data.existingExamSheetCodes);
              } else {
                setNewExamSheetID(result.data.id);
                setIsSuccess(true);
                props.onCreation();
              }
            }
          },
          () => {
            setIsError(true);
          },
        )
        .finally(() => {
          setIsImporting(false);
          showLoader(false);
        });
    }
  };

  const handleNewSessionDetails = (type: string, year: number, month: number, isTraining: boolean) => {
    const examSession: ExamSession = {
      name: name,
      sessionType: type,
      year: year,
      month: month,
      isTraining: isTraining,
    };

    showLoader(true, 'Zapisywanie danych');
    saveSessionCreatedManually(examSession)
      .then(
        (result: AxiosResponse<ISavedSessionCreatedManually>) => {
          setNewExamSheetID(result.data.id);
          setOnNewSessionAdded(() => () => {
            goToDetails(result.data.id);
            props.onCreation();
          });
          setIsNewSessionAddedOpen(true);
        },
        () => {
          setIsError(true);
        },
      )
      .finally(() => {
        showLoader(false);
      });
  };

  const getImportedSheets = () => {
    return existingExamSheetCodes.join(', ');
  };

  return (
    <>
      <ButtonOne className={classes.button} variant="contained" color="primary" onClick={handleClickOpen}>
        <span style={{ margin: '0px 10px 0px -4px', fontSize: '20px' }}>+</span> {t('sessions:header.addSessionButton')}
      </ButtonOne>
      <Dialog
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            setOpen(false);
          }
        }}
        aria-labelledby="dodaj sesję"
        open={open}
        maxWidth={false}
      >
        {stage1 && <AddName handleAddName={handleAddName} onActivateTrainingSession={setIsTrainingSession} />}
        {stage2 && <ImportSession handleImportSession={handleImportSession} />}
        {stage3 && <SelectSystem handleSelectSystem={handleSelectSystem} handleLoader={setIsImporting} />}
        {stage4 && system && (
          <SelectSession
            selectedSystem={system}
            handleLoader={setIsImporting}
            handleClose={handleClose}
            handleStageFourAndSave={handleStageFourAndSave}
          />
        )}
        {stageSessionDetails && (
          <NewSessionDetails
            handleClose={handleClose}
            handleNewSessionDetails={handleNewSessionDetails}
            isTrainingSession={isTrainingSession}
          />
        )}
        <Prompt
          type="success"
          open={isSuccess}
          mainText="Dane sesji egzaminacyjnej zostały dodane pomyślnie."
          mainActionButtonText="EDYTUJ DANE SESJI"
          onConfirm={() => {
            setIsSuccess(false);
            goToDetails();
          }}
        />
        <Prompt
          type="error"
          open={isError}
          mainText="Dodanie sesji egzaminacyjnej nie powiodło się."
          subTexts={
            isImportedSheetsError
              ? [{ text: 'Ponieważ w systemie istnieją już arkusze:' }, { text: getImportedSheets() }]
              : [{ text: 'Spróbuj ponownie później.' }]
          }
          mainActionButtonText="POWRÓT DO LISTY"
          onConfirm={() => {
            setIsError(false);
            setOpen(false);
          }}
        />

        <Prompt
          type="success"
          open={isNewSessionAddedOpen}
          mainText={
            isTrainingSession ? 'Treningowa sesja egzaminacyjna została dodana.' : 'Sesja egzaminacyjna została dodana.'
          }
          mainActionButtonText="PRZEJDŹ DO EDYCJI"
          onConfirm={() => {
            if (onNewSessionAdded) {
              onNewSessionAdded();
              setOnNewSessionAdded(null);
            }
            setIsNewSessionAddedOpen(false);
          }}
        />
      </Dialog>
    </>
  );
};
export default SessionCreate;
